<mat-form-field appearance="outline">
  <mat-label>Company name</mat-label>
  <mat-select [ngModel]="currentEntityId" name="Loan" (selectionChange)="changeEntity($event.value)">
    <mat-option *ngFor="let entity of entities" [value]="entity?.id">
      {{ entity.dba || entity.name }}
    </mat-option>
  </mat-select>
</mat-form-field>
